// extracted by mini-css-extract-plugin
export default {"posts":"PostsList_posts__DYm39"};